/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.o-search-input {
  display: flex;
  flex-direction: column;
  row-gap: 0.9375rem;
}
.o-search-input__input {
  position: relative;
  display: flex;
  width: initial;
  flex: 0 1 100%;
}
.o-search-input__input-label {
  position: absolute;
  left: 10px;
  align-self: center;
  cursor: pointer;
}
.o-search-input__input input[type=search] {
  width: 100%;
  white-space: nowrap;
  padding-left: 30px;
  appearance: none;
}
.o-search-input__input button[type=reset] {
  display: none;
  position: absolute;
  right: 0;
  align-self: center;
  color: var(--gray-40);
  font-size: 20px;
  border: 1px solid transparent;
  background-color: transparent;
  outline: 0;
  width: 44px;
  padding: 5px;
  text-align: right;
}
.o-search-input__input button[type=reset] > svg {
  width: 25px;
  cursor: pointer;
  pointer-events: none;
}
.o-search-input__input button[type=reset]:hover {
  color: var(--black);
}
.o-search-input__input button[type=reset]:focus {
  color: var(--black);
}
.o-search-input__input button[type=reset]:focus > svg {
  outline: 1px dotted var(--pacific);
}
.o-search-input__input input[type=search]:placeholder-shown ~ button[type=reset] {
  display: none;
}
.o-search-input__input input[type=search]:not(:placeholder-shown) {
  padding-right: 34px;
}
.o-search-input__input input[type=search]::-webkit-search-decoration,
.o-search-input__input input[type=search]::-webkit-search-cancel-button,
.o-search-input__input input[type=search]::-webkit-search-results-button,
.o-search-input__input input[type=search]::-webkit-search-results-decoration {
  display: none;
}
.o-search-input:focus-within button[type=reset], .o-search-input .o-search-input__input:hover button[type=reset] {
  display: block;
}
.o-search-input button[type=submit] {
  line-height: 1.1875;
}
@media only all and (min-width: 37.5625em) {
  .o-search-input {
    flex-direction: row;
    border-left: 0;
  }
  .o-search-input button[type=submit] {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    flex-basis: 25%;
  }
}

.no-js .o-search-input button[type=reset] {
  display: none !important;
}